import React, { memo, useState } from 'react';
import { useAsyncDebounce } from 'react-table';
import { SearchInput } from '@tonic-ui/react';

type TableSearchFilterProps = {
  onSearch(value: string): () => void;
  placeholder: string;
};

export const TableSearchFilter = ({
  onSearch,
  placeholder = 'Search...',
}: TableSearchFilterProps): JSX.Element => {
  const [searchValue, setSearchValue] = useState('');

  // For large amounts of data, the useAsyncDebounce hook can debounce the onChange event in the filter
  const onDebounce = useAsyncDebounce((searchValue) => {
    onSearch(searchValue);
  }, 300);

  const handleClear = () => {
    onSearch('');
    setSearchValue('');
  };

  return (
    <SearchInput
      width="100%"
      placeholder={placeholder}
      value={searchValue || ''}
      onChange={(e) => {
        setSearchValue(e.target.value);
        onDebounce(e.target.value);
      }}
      onClearInput={handleClear}
    />
  );
};

export default memo(TableSearchFilter);
